// extracted by mini-css-extract-plugin
export default {"container":"DetailsV1_container__q2VrP"};